import { createSelector } from '@reduxjs/toolkit';
import { DropdownItemProps } from 'semantic-ui-react';

import { InsightsState } from 'app-redux/InsightsState';

import { MapDiseaseRelevance2DiseaseNotificationLevelDict } from 'components/SidebarView/SettingsView/CustomSettings/CustomSettingsHelpers';
import { RoleAndItsPresets } from 'components/SidebarView/SettingsView/CustomSettings/CustomSettingsModels';

export const userProfileSelector = (state: InsightsState) => state?.user?.userProfile;
export const rolesSelector = (state: InsightsState) => state?.user?.roles;
export const groupsSelector = (state: InsightsState) => state?.user?.groups;
export const isSettingsLoadingSelector = (state: InsightsState) => state?.user?.isLoadingSettings;
export const isSettingsSubmittingSelector = (state: InsightsState) => state?.user?.isSubmittingSettings;

export const mapRolesWithPresets = createSelector(rolesSelector, roles =>
  (roles ?? []).map(
    role =>
      ({
        id: role.id,
        name: role.name,
        notificationDescription: role.notificationDescription,
        preset: MapDiseaseRelevance2DiseaseNotificationLevelDict(role.relevanceSettings),
      } as RoleAndItsPresets)
  )
);
export const rolesAsDropdownItems = createSelector(mapRolesWithPresets, roles =>
  (roles ?? []).map(role => ({ key: role.id, value: role.id, text: role.name || 'Select a role' } as DropdownItemProps))
);
